/* @flow */
import React, { Component } from "react";
import { connect } from "react-redux";
import messages from "./Collaborators.messages";

import * as actions from "../../../../redux/collaborators/actions";
import {
  loadCollaborators,
  loadCollaboratorInvites,
  getCollaborators,
  getInvites,
  inviteCollaborator,
} from "../../../../redux/collaborators";

import { getUser, isLoggedIn, getPlanName } from "../../../../redux/user";

import type Collaborator from "../../../../models/Collaborator";
import type CollaboratorInvite from "../../../../models/CollaboratorInvite";
import type CollaboratorInviteCollection from "../../../../models/CollaboratorInviteCollection";
import type CollaboratorCollection from "../../../../models/CollaboratorCollection";
import type Project from "../../../../models/Project";
import type User from "../../../../models/User";
import { Table, Button } from "react-bootstrap";
import styles from "./Collaborators.styles";
import CollaboratorModal from "../../components/modals/collaborator-modal/CollaboratorModal";
import SubscribeModal from "../../components/modals/subscribe-modal/SubscribeModal";
import GradientButton from "../../../../components/input/GradientButton";
import {
  accountExpired,
  canAddCollaborator,
  findPlanName,
  isMobile,
  hasCollaboratorsLeft,
} from "../../../../helpers/Utils";

type Props = {
  user: User,
  project: Project,
  handleAddCollaborator: (email: string) => void,
  showCollaboratorInvite: boolean,
  onPress: () => void,
  showInvite: boolean,
  isOwner: boolean,
};

type State = {
  project: ?Project,
  collaborators: CollaboratorCollection,
  invites: CollaboratorInviteCollection,
  showCollaboratorModal: boolean,
  showSubscribeModal: boolean,
};

// $FlowFixMe
class Collaborators extends Component {
  props: Props;
  state: State = {
    showCollaboratorModal: false,
    showSubscribeModal: false,
  };

  openCollaboratorModal = () => {
    this.setState({
      showCollaboratorModal: true,
    });
  };

  closeCollaboratorModal = () => {
    this.setState({
      showCollaboratorModal: false,
    });
  };

  openSubscribeModal = () => {
    this.setState({
      showSubscribeModal: true,
    });
  };

  closeSubscribeModal = () => {
    this.setState({
      showSubscribeModal: false,
    });
  };

  handleAddCollaborator = () => {
    if (
      canAddCollaborator(
        this.props.user,
        this.props.collaborators,
        this.props.invites
      )
    ) {
      this.openCollaboratorModal();
    } else {
      this.openSubscribeModal();
    }
  };

  render() {
    const { project } = this.props;
    if (!project || !this.props.user) return null;

    return (
      <div className="collaborators-container">
        <div className="title-container">
          <h4>Collaborators:</h4>
          {!!this.props.isOwner && (
            <GradientButton
              title="+ Add Collaborator"
              handleClick={this.handleAddCollaborator}
            />
          )}
        </div>
        <Table striped hover className="collaborators-table">
          <thead className="with-bottom-border">
            <tr>
              <th>Name/email</th>
              <th>Status</th>
            </tr>
          </thead>
          {this.renderTableBody()}
        </Table>
        {this.state.showCollaboratorModal ? this.renderCollaboratorModal() : ""}
        {this.state.showSubscribeModal ? this.renderSubscribeModal() : ""}
      </div>
    );
  }

  renderAddButton() {
    return (
      <Button
        bsStyle="primary"
        bsSize="xsmall"
        className="m-r-5"
        style={styles.button}
        onClick={() => this.handleAddCollaborator()}
      >
        + Collaborator
      </Button>
    );
  }

  renderTableBody() {
    if (
      this.props.collaborators.length === 1 &&
      this.props.invites.length === 0
    ) {
      return (
        <tbody>
          <tr>
            <td colSpan="2">No collaborators</td>
          </tr>
        </tbody>
      );
    } else {
      return (
        <tbody className="deuppercase-children">
          {this.renderInvites()}
          {this.renderCollaborators()}
        </tbody>
      );
    }
  }

  renderInvites() {
    if (!this.props.invites) {
      return null;
    }
    const invites = this.props.invites.uniqByEmail().toArray();
    return invites.map(this.renderInvite);
  }

  renderInvite(invite: CollaboratorInvite) {
    return (
      <tr key={invite.id}>
        <td>{invite.email}</td>
        <td>Invite Sent</td>
      </tr>
    );
  }

  renderCollaborators() {
    if (!this.props.user) {
      return null;
    }
    const collaborators = this.props.collaborators
      .removeByUser(this.props.user.id)
      .toArray();
    return collaborators.map(this.renderCollaborator);
  }

  renderCollaborator(collaborator: Collaborator) {
    return (
      <tr key={collaborator.id}>
        <td>
          {collaborator.firstName} {collaborator.lastName}
        </td>
        <td>Joined</td>
      </tr>
    );
  }

  renderCollaboratorModal = () => {
    return (
      <CollaboratorModal
        onModalClose={() => this.closeCollaboratorModal()}
        user={this.props.user}
        project={this.props.activeProject}
      ></CollaboratorModal>
    );
  };

  renderSubscribeModal = () => {
    const alertMessage = this.renderAlertMessage();
    return (
      <SubscribeModal
        user={this.props.user}
        onModalClose={() => this.closeSubscribeModal()}
        alertMessage={alertMessage}
      ></SubscribeModal>
    );
  };

  renderAlertMessage() {
    const planName = findPlanName(this.props.user);

    if (isMobile()) return messages.mobileMessage;
    if (accountExpired(this.props.user)) return "Account Expired";
    switch (planName) {
      case "Trial":
        return messages.trialMessage;
      case "Simple":
        return messages.singleMessage;
      case "Basic":
        return messages.basicMessage;
      case "Standard":
        return messages.standardMessage;
      case "Premier":
        return messages.premierMessage;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    isLoggedIn: isLoggedIn(state),
  };
};

export default connect(mapStateToProps, actions)(Collaborators);



// WEBPACK FOOTER //
// ./src/views/user/agenda/collaborators/Collaborators.js